// Same-origin path proxied to core-api by Apache, so the httpOnly user_pkey
// cookie authenticates GraphQL requests without exposing the session token.
export const GRAPHQL_URI = '/graphql';
